import React from "react";

const WHATSAPP_LINK = "https://wa.me/573184215616";

const WhatsAppFloatingButton = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Hablar por WhatsApp"
      className="whatsapp-float-cta fixed bottom-6 right-6 z-50"
    >
      <div className="relative flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-[0_10px_30px_-12px_rgba(0,0,0,0.45)] ring-1 ring-black/5 transition-transform hover:scale-105">
        <span
          className="whatsapp-float-ring pointer-events-none absolute inset-0 rounded-full"
          aria-hidden="true"
        />
        <div className="whatsapp-float-icon flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] shadow-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="h-7 w-7 fill-white"
            aria-hidden="true"
          >
            <path d="M19.11 17.87c-.27-.14-1.6-.79-1.84-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.15-.42-2.2-1.35-.82-.72-1.37-1.6-1.53-1.87-.16-.27-.02-.41.12-.55.13-.13.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.02-.22-.53-.44-.46-.61-.46h-.52c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.33.98 2.62 1.12 2.8.14.18 1.93 2.95 4.67 4.13.65.28 1.16.45 1.56.58.65.21 1.25.18 1.72.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32z" />
            <path d="M16.04 2C8.8 2 2.91 7.89 2.91 15.13c0 2.54.66 4.99 1.92 7.16L3 30l7.95-1.81a13.1 13.1 0 0 0 5.09 1.01h.01c7.23 0 13.12-5.89 13.12-13.13C29.17 7.89 23.28 2 16.04 2zm0 24.03h-.01a10.9 10.9 0 0 1-4.63-1.02l-.33-.15-4.71 1.07 1.01-4.59-.17-.35a10.93 10.93 0 1 1 8.84 5.04z" />
          </svg>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppFloatingButton;
